export default __webpack_public_path__ + "e.png";